import { withProps } from 'recompose';
import { isEditMode } from '../helpers/isEditMode';
import { t } from '../../../../../../modules/infra/i18n';

const withHeading = withProps(props => ({
  heading: isEditMode(props) ? t('barber:brand_barber.heading.edit') : t('barber:brand_barber.heading.add'),
}));

export default withHeading;
